import React from 'react';
import { Button } from '@components/Button/Button';

export interface FeedbackErrorProps {
  message?: string;
  description?: string;
  /** When given, renders a "Coba lagi" button (44px tall below `md`). */
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

/** Inline error card rendered in place of the content that failed to load. */
export const FeedbackError: React.FC<FeedbackErrorProps> = ({
  message = 'Gagal memuat data',
  description,
  onRetry,
  retryLabel = 'Coba lagi',
  className = '',
}) => (
  <div
    role="alert"
    aria-live="polite"
    className={`flex flex-col items-center rounded-xl border border-red-200 bg-red-50 px-4 py-6 text-center ${className}`.trim()}
  >
    <i
      aria-hidden="true"
      data-testid="feedback-error-icon"
      className="ri-error-warning-line mb-2 text-3xl leading-none text-red-700"
    />
    <p className="text-[15px] font-medium text-gray-900">{message}</p>
    {description && (
      <p className="mt-1 max-w-prose text-sm text-gray-600">{description}</p>
    )}
    {onRetry && (
      <Button
        variant="white"
        size="small"
        onClick={onRetry}
        className="mt-4 min-h-[44px] md:min-h-0"
      >
        <i aria-hidden="true" className="ri-refresh-line mr-1 text-[14px]" />
        {retryLabel}
      </Button>
    )}
  </div>
);

export default FeedbackError;
